import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import ServiceArea from "@/components/ServiceArea";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import MobileStickyCTA from "@/components/MobileStickyCTA";

export default function Landing() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <main data-testid="landing-main">
        <Hero />
        <Services />
        <WhyUs />
        <ServiceArea />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
